<template lang="pug">
	.training-videos-detail
		Loader(v-if="isLoading", :fullscreen="true")
		template(v-if="trainingVideo")
			.flex-col.space.padding
				.flex-row.justify.space.align-center
					.font-large {{trainingVideo.Name}}
					a.flex-row.space.align-center(@click="$router.push({ path: '/training-videos' })")
						span {{$tCaption('Back to videos list')}}
						fas(icon="arrow-right")
				.font-big(v-if="trainingVideo.Description") {{trainingVideo.Description}}
			.flex-col.align-center.align-center.player(v-if="isVideo && trainingVideo && trainingVideo.Url")
				.vimeo-player(v-if="isVimeo", :id="divId", ref="vimeo")
				.youtube-player(v-else-if="isYoutube", :id="divId", :style="{}" ref="youtube")
			.lr-padding(v-if="!isVideo")
				DxButton(@click="openLink", icon="fas fa-magnifying-glass", :text="$tCaption('View')")
</template>

<script>
	import Loader from 'app-core/Loader.vue';
	import dynamic from 'dynamic';
	import DxButton from 'devextreme-vue/button';

	export default {
		translationCategory: 'training-videos.Detail',
		name: 'training-videos-detail',
		components: {
			Loader, DxButton
		},
		props: ['id'],
		data() {
			return {
				isLoading: false,
				trainingVideo: null
			};
		},
		created() {
			
		},
		computed: {
			isVideo() {
				return this.isVimeo || this.isYoutube;
			},
			frameHeight() {
				return Math.max(360, window.innerHeight - 300);
			},
			divId() {
				return `video_${this.trainingVideo?.Oid}`;
			},
			isVimeo() {
				return `${this.trainingVideo?.Url}`.indexOf('vimeo') > -1;
			},
			isYoutube() {
				return ['y2u.be', 'youtube'].some(f => `${this.trainingVideo?.Url}`.indexOf(f) > -1);
			},
			vimeoId() {
				const items = `${this.trainingVideo?.Url}`.split('/');
				return items[items.length - 1];
			},
			youtubeId() {
				return new URLSearchParams(`${this.trainingVideo?.Url}`.split('?')[1]).get('v');
			},
			isGuid() {
				return this.id.length === 36 && this.id.indexOf('-') === 8;
			}
		},
		watch: {
			id() {
				this.loadData();
			}
		},
		mounted() {
			if (__DEBUG__)
				window.trainingVideosDetail = this;
			this.loadData();
		},		
		methods: {
			openLink() {
				window.open(this.trainingVideo.Url, '_blank');
			},	
			loadData() {
				this.isLoading++;
				this.trainingVideo = null;
				if (this.isGuid) {
					this.$Data.getExternalApi('TrainingVideo/GetTrainingVideo', `id=${this.id}`).then(r => {
						this.trainingVideo = r;
						return this.initVideo();
					}).finally(() => this.isLoading--);
				} else {
					this.$Data.getExternalApi('TrainingVideo/GetAllTrainingVideos', 'page=0', 9999).then(r => {
						this.trainingVideo = r.Results.find(f => f.Name === this.id);
						if (!this.trainingVideo) {
							this.$router.push({ path: '/training-videos' });
							return;
						}
						return this.initVideo();
					}).finally(() => this.isLoading--)
				}
			},
			async initVideo() {
				if (!this.trainingVideo?.Url) return;
				if (this.isVimeo) return this.initVimeoVideo();
				if (this.isYoutube) return this.initYoutubeVideo();
			},
			initVimeoVideo() {
				return dynamic.loadOnce(['https://player.vimeo.com/api/player.js']).then(() => {
					const options = {
						id: this.trainingVideo?.Url,
						height: this.frameHeight,
						loop: false,
						controls: true
					};
					const player = new Vimeo.Player(this.divId, options);

					//player.setVolume(1);

					player.on('play', function() {
						console.log('played the video!');
					});
				});
			},
			initYoutubeVideo(){
				this.$nextTick(() => {
					var iframe = document.createElement( "iframe" );
					iframe.setAttribute("allowfullscreen", "");
					iframe.setAttribute("frameborder", "0");
					iframe.setAttribute("src", "https://www.youtube.com/embed/" + this.youtubeId + "?rel=0&showinfo=0&autoplay=0");
					iframe.setAttribute("height", this.frameHeight);
					iframe.setAttribute("width", this.$el.offsetWidth);

					this.$refs.youtube.innerHTML = "";
					this.$refs.youtube.appendChild(iframe);
				});
			}
		}
	};
</script>

<style lang='scss'>
	.training-videos-detail {
		.player {
			background: #000;

			.vimeo-player {
				iframe {
					margin-bottom: -5px;
				}
			}
		}
	}
</style>
